import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Role } from 'src/app/auth/models/user';
import { LoaderService } from 'src/app/auth/services/loader.service';
import * as moment from 'moment';
import { Users } from 'src/app/modules/users/models/users';
import { Organization } from 'src/app/modules/organization-admin/models/organization';
import { AuthenticationService } from 'src/app/auth/services/authentication.service';
import { OrganizationAdminService } from 'src/app/modules/organization-admin/services/organization-admin.service';
import { LeavesService } from '../../services/leaves.service';
import { LeaveCreateComponent } from '../leave-create/leave-create.component';
import { delay } from 'rxjs/operators';
import { UsersService } from 'src/app/modules/users/services/users.service';
import { CURRENT_PAGE, ITEMS_PER_PAGE, PAGE_LENGTH, PAGE_SIZE_OPTIONS } from 'src/app/shared/constants/pagination.constants';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
const dialogConfig = new MatDialogConfig();
dialogConfig.disableClose = true;
dialogConfig.autoFocus = true;

@Component({
  selector: 'app-leaves-details',
  templateUrl: './leaves-details.component.html',
  styleUrls: ['./leaves-details.component.css']
})
export class LeavesDetailsComponent implements OnInit, AfterViewInit {

  @ViewChild('paginator', { static: true }) paginator: MatPaginator;

  displayedColumns: string[] = ['org_name', 'applied_user', 'leave_from', 'leave_to', 'from_session', 'to_session', 'leave_days', 'leave_reason', 'applied_to', 'leave_status'];

  public leavesDataSource: MatTableDataSource<any>;
  public Role = Role;
  public searchUserNameCtrl = new FormControl('', Validators.required);
  public users: Users;
  public hasRole: string = this.authservice.hasRole();
  public orgId: string = this.authservice.getOrgId();
  public organizations: Organization[];
  public isShowOrganization: boolean = false;
  public PAGE_SIZE_OPTIONS_DATA:number[] = PAGE_SIZE_OPTIONS;

  public page_length:number = PAGE_LENGTH;

  public items_per_page:number = ITEMS_PER_PAGE;

  public current_page:number = CURRENT_PAGE;
  public fromMaxDate:Date;
  public fromMinDate:Date;
  public toMaxDate:Date;
  public toMinDate:Date;
  constructor(
    private authservice: AuthenticationService,
    private organizationService: OrganizationAdminService,
    private leaveService: LeavesService,
    private dialog: MatDialog,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    private loaderService: LoaderService,
    private fb: FormBuilder,
    private userService:UsersService,

  ) { }
  filterParamsr={};
  // users = [...] // Your array of users
  selectedUser: any; // Define the selectedUser variable

  onSelectionChange(event: any) {
    // Handle the selection change
    this.selectedUser = event.value;
  }

  selectAll() {
    // Handle the "All" option selection
    this.selectedUser = 'all';
  }
  // filterParams={'user_id':'','per-page':25,'page':1,'from_date':'','to_date':''};
  ngOnInit(): void {
    this.loadIcon();
    this.getLeaves(this.filterParamsr);
    this.getUsers(this.orgId);
    this.createAdvancedSearchForm();
    this.searchUserName();


    if (this.hasRole == '1') {
      this.isShowOrganization = true;
      this.getOrganizations();
    }
  }

  ngAfterViewInit() {
    if (this.leavesDataSource != undefined) {
      this.leavesDataSource.paginator = this.paginator;
    }
  }

  loadIcon(): void {
    this.matIconRegistry.addSvgIcon(
      "filter",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/SVG/filter.svg")
    );
  }

  getOrganizations(): void {
    this.organizationService.getOrganizations().subscribe(
      (res: any) => {
        this.organizations = res.body;
      }
    );
  }

  getLeaves(filterParamss:any): void {
    this.loaderService.isTableLoding.next(true);

    let filterParams = this.addFilterParameters();
    filterParams["user_id"] = this.AdvancedSearchForm.value.user_id;
    filterParams["from_date"] = this.AdvancedSearchForm.value.from_date;
    filterParams["to_date"] = this.AdvancedSearchForm.value.to_date;
    this.leaveService.getLeaves(filterParams).subscribe(
      (res)=>{
        // console.log(`Responsive Data :: `,res);
        this.loaderService.isTableLoding.next(false);

        this.page_length = res.headers.get('X-Pagination-Total-Count');
        this.current_page = res.headers.get('X-Pagination-current-page');
        this.items_per_page = res.headers.get('X-Pagination-Per-Page');
        this.leavesDataSource = new MatTableDataSource<any>(res.body);
      }
    );
  }

  AdvancedSearchForm = new FormGroup({
    org_id: new FormControl(),
    from_date: new FormControl(),
    to_date: new FormControl(),
    user_id: new FormControl()
  });

  createAdvancedSearchForm(): void {
    this.AdvancedSearchForm = this.fb.group({
      org_id: [this.orgId],
      user_id: ['', [Validators.required]],
      from_date: [''],
      to_date: [''],
    });
  }

  createLeave(): void {
    dialogConfig.width = "40%";
    dialogConfig.data = {
      holiday_id: undefined
    };

    this.dialog.open(LeaveCreateComponent, dialogConfig);

    // this.dialog.afterAllClosed.subscribe(e => {
    //   this.getLeaves();
    // });
  }

  organizationChange(event): void {
    this.getUsers(event.source.value);
  }

  getUsers(orgId: string = undefined): void {
    let filterParams = {};

    filterParams["sort"] = "-id";

    if (orgId != undefined) {
      filterParams['filter[org_id]'] = orgId;
    }

    let searchParams = this.searchUserNameCtrl.value;

    if (searchParams != '' && searchParams.length >= 3) {
      filterParams['filter[name][like]'] = searchParams.trim();
    }

    this.userService.getUsersList(filterParams).subscribe(
      (res: any) => {
        this.users = res.body;
      }
    );
  }

  addFilterParameters(): Object {
    let filterParams = {};
    filterParams['page'] = this.current_page;
    filterParams["per-page"] = this.items_per_page;
    filterParams["sort"] = "-id";
    return filterParams;
  }
  addFilterParametersl(): Object {
    let filterParams = {};
    filterParams['page'] = this.current_page;
    filterParams["per-page"] = this.items_per_page;
    filterParams["sort"] = "-id";
    return filterParams;
  }

  handlePage(e?: any): void {
    let filterParams = {};

    if (e) {
      this.current_page = e.pageIndex + 1;
      this.items_per_page = e.pageSize;
      this.page_length = e.length;
    }
    this.getLeaves(filterParams);
  }

  AdvancedSearchFormSubmit(): void {
    // if (this.AdvancedSearchForm.invalid) {
    //   return;
    // }

    if (this.AdvancedSearchForm.value.from_date != "")
      this.AdvancedSearchForm.patchValue({
        from_date: moment(this.AdvancedSearchForm.value.from_date).format("YYYY-MM-DD"),
      });

    if (this.AdvancedSearchForm.value.to_date != "")
      this.AdvancedSearchForm.patchValue({
        to_date: moment(this.AdvancedSearchForm.value.to_date).format("YYYY-MM-DD"),
      });
      const user_id = this.AdvancedSearchForm.value.user_id;
console.log(user_id);


    let filterParams = this.addFilterParameters();

    filterParams["user_id"] = user_id;
    filterParams["from_date"] = this.AdvancedSearchForm.value.from_date;
    filterParams["to_date"] = this.AdvancedSearchForm.value.to_date;
console.log(filterParams);
    this.getLeaves(filterParams);
  }

  

  
  onFromDateChange(event):void{
    this.toMinDate = event.target.value;
  }

  /*** TO SET FROM_DATE MAXIMUM VALUE, WHICH IS NOTHING BUT CURRENT VALUE OF TO_DATE ***/
  onToDateChange(event):void{
    this.fromMaxDate = event.target.value;
  }

  refreshData(){
    this.AdvancedSearchFormSubmit();
  }

  searchUserName(){
      this.searchUserNameCtrl.valueChanges
      .pipe(
        delay(300),
      )
      .subscribe(val=> {
        this.AdvancedSearchForm.patchValue({
          'user_id': (this.searchUserNameCtrl.value != null)?this.searchUserNameCtrl.value.id:''
        });
console.log(this.AdvancedSearchForm);
if(this.AdvancedSearchForm.value.user_id != 'null'){
        this.getUsers(this.AdvancedSearchForm.value.org_id);
}
      });
  }

  displaySearchUserName(users:Users) {
    if (users) { return users.name; }
  }
  onOptionSelected(event: MatAutocompleteSelectedEvent): void {
    let selectedValue = event.option.value;
    let filterParams = {};
    filterParams['page'] = this.current_page;
    filterParams["per-page"] = this.items_per_page;
    filterParams["sort"] = "-id"; 
    filterParams["user_id"] = 'null';

    if (selectedValue == 'al') {
        // Empty the filterParams object
        filterParams = {};
        filterParams["user_id"] = {};
        window.location.href = window.location.href;
    }

    //this.getLeaves(filterParams);
    //this.getLeaves(filterParams);
}

}
